import { Box, Stack, styled } from '@mui/material';

const ModalInner = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    width: 600,
  },
  [theme.breakpoints.up('lg')]: {
    width: 900,
  },
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  border: `2px solid ${theme.palette.grey[600]}`,
  borderRadius: 6,
  boxShadow:
    '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
}));

const ModalBody = styled(Stack)({
  padding: 16,
  alignSelf: 'center',
  maxWidth: 640,
  width: '100%',
});

const Video = styled('video')({
  display: 'block',
  width: '100%',
  alignSelf: 'center',
});

export { ModalInner, ModalBody, Video };
